import React, { Component } from "react"
import { Input, Table, message ,Switch} from "antd"
import editAbleIcon from "app/styles/images/sp/edit.svg"
import MaterialModal from "app/components/normal/MaterialModal"
import { observer, inject } from "mobx-react"
import closeIcon from "app/styles/images/sp/close.svg"
import MaterialForm from "app/components/normal/MaterialForm/MaterialForm"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"

@inject("auth") @observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showEditModal: false,
    }
  }

  componentDidMount() {
    const { store: { list } } = this.props
    list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
          list.initPageIndex()
        }
      )
  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        list
      },
    } = this.props

    list.changePagin(selectedPageNumber)

    document.getElementById("contentTop").scrollIntoView(true)
  }

  showEditModal = (record) => {
    this.setState({
      showEditModal: true,
    })
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false
    })
  }

  handleEdit = (id) => {
    const { getOrgDetail } = this.props.store
    getOrgDetail(id).then(
      res => {
        this.setState({
          showEditModal: true,
        })
      }
    )

  }
  onChangeRecordState= (record) => {
    // console.log(record)
  }

  render() {
    const { detailData, setDetailData, updateOrg } = this.props.store

    const {
      store: {
        list: {
          tableData,
          totalCount,
          queryMap,
          currentPageIndex,
        }
      },
    } = this.props

    const columns = [{
       
      title: (<div className="ta-c">ID</div>),
      className: "ta-c",
      dataIndex: "id",
      render: (text, record, index) => {
        return (
          <div>{text || "-"}</div>
        )
      }
    },{
      title: (<div className="ta-c">用户ID</div>),
      className: "ta-c",
      dataIndex: "userId",
      render: (text) => {
        return (
          <div>{text || "-"}</div>
        )
      }
    },  {
        title: (<div className="ta-c">模版名称</div>),
        className: "ta-c",
        dataIndex: "name",
        render: (text) => {
          return (
            <div>{text || "-"}</div>
          )
        }
      }, {
        title: (<div className="ta-c">模版类型</div>),
        className: "ta-c",
        dataIndex: "type",
        render: (text) => {
          return (
            <div>{text || '-'}</div>
          )
        }
      }, {
       
        title: (<div className="ta-c">机构ID</div>),
        className: "ta-c",
        dataIndex: "orgId",
        render: (text) => {
          return (
            <div>{text || "-"}</div>
          )
        }
      },
      // {
      //   title: (<div className="ta-c">template</div>),
      //   className: "ta-c",
      //   dataIndex: "template",
      //   render: (text, ) => {
      //     return (
      //       <div>{text || "-"}</div>
      //     )
      //   }
      // },
       {
       
        title: (<div className="ta-c">一级标题</div>),
        className: "ta-c",
        dataIndex: "appType",
        render: (text) => {
          return (
            <div>{text || "-"}</div>
          )
        }
      },{
       
        title: (<div className="ta-c">二级标题</div>),
        className: "ta-c",
        dataIndex: "appGroupName",
        render: (text) => {
          return (
            <div>{text || "-"}</div>
          )
        }
      },{
        title: (<div className="ta-c">模版格式</div>),
        className: "ta-c",
        dataIndex: "format",
        render: (text) => {
          return (
            <div>{text || '-'}</div>
          )
        }
      },{
        title: (<div className="ta-c">停启状态</div>),
        className: "ta-c",
        dataIndex: "recordState",
        render: (text) => {
          return (
            <div>
              {text === 1 && <div style={{ color: 'red' }}>停用</div>}
              {text === 0 && <div style={{ color: 'green' }}>启用</div>}
              {text !== 0 && text !== 1 && <div>-</div>}
            </div>
          )
        }
      },{
        title: (<div className="ta-c">操作</div>),
        dataIndex: "operator",
        className: "ta-c",
        render: (text, record) => {
          return (
            <div>
              <img
                title="修改"
                src={editAbleIcon}
                alt=""
                style={{ cursor: 'pointer' }}
                onClick={() => this.handleEdit(record.id)}
              />
            </div>
          )
        }
      }
    ]

    return (
      <div className="wrapper-box">
        <Table
          columns={columns}
          className="statistics-table"
          rowKey={record => record.id}
          dataSource={tableData.slice()}
          pagination={{
            pageSize: queryMap.limit,
            onChange: this.onPaginChange,
            defaultCurrent: 1,
            current: currentPageIndex,
            total: totalCount,
          }}
        />
        <MaterialModal
          title="编辑模版"
          width={450}
          className="preview-account-create-modal"
          visible={this.state.showEditModal}
          buttonText="确认提交"
          action={
            () => {
              return updateOrg()
                .then(
                  res => {
                    message.success('修改成功')
                    this.closeModal('showEditModal')
                  }
                )
            }

          }
        >
          <img
            className="pgx-modal-close"
            src={closeIcon}
            alt="关闭对话框"
            onClick={() => this.closeModal("showEditModal")}
          />
          <MaterialForm>
            <MaterialFormItem
              labelText="用户ID"
              labelWidth={60}
            >
              <Input
                name="userId"
                className="createAccount-input"
                placeholder="请输入用户ID"
                value={detailData.get('userId')}
                onChange={(e) => setDetailData({ userId: e.target.value })}
              />
            </MaterialFormItem>
            <MaterialFormItem
              labelText="模版名称"
              labelWidth={60}
            >
              <Input
                name="name"
                className="createAccount-input"
                placeholder="请输入模版名称"
                value={detailData.get('name')}
                onChange={(e) => setDetailData({ name: e.target.value })}
              />
            </MaterialFormItem>
            <MaterialFormItem
              labelWidth={60}
              labelText="模版类型"
              justify="center"
            >
              <Input
                name="type"
                className="createAccount-input"
                placeholder="请输入模版类型"
                value={detailData.get('type')}
                onChange={(e) => setDetailData({ type: e.target.value })}
              />
            </MaterialFormItem>
           
            <MaterialFormItem
              labelWidth={60}
              labelText="机构ID"
              justify="center"
            >
              <Input
                name="orgId"
                className="createAccount-input"
                value={detailData.get('orgId')}
                placeholder="请输入机构ID"
                onChange={(e) => setDetailData({ orgId: e.target.value })}
              />
            </MaterialFormItem>
            <MaterialFormItem
              labelWidth={60}
              labelText="一级标题"
              justify="center"
            >
              <Input
                name="appType"
                className="createAccount-input"
                value={detailData.get('appType')}
                placeholder="请输入一级标题"
                onChange={(e) => setDetailData({ appType: e.target.value })}
              />
            </MaterialFormItem>
            <MaterialFormItem
              labelWidth={60}
              labelText="二级标题"
              justify="center"
            >
              <Input
                name="appGroupName"
                className="createAccount-input"
                value={detailData.get('appGroupName')}
                placeholder="请输入二级标题"
                onChange={(e) => setDetailData({ appGroupName: e.target.value })}
              />
            </MaterialFormItem>

            <MaterialFormItem
              labelWidth={60}
              labelText="模版格式"
              justify="center"
            >
              <Input
                name="format"
                value={detailData.get('format')}
                className="createAccount-input"
                placeholder="请输入模版格式"
                onChange={(e) => setDetailData({ format: e.target.value })}
              />
            </MaterialFormItem>
            <MaterialFormItem
              labelWidth={60}
              labelText="停启状态"
              justify="center"
            >
              <div style={{width: 280}}>
                <Switch 
                  name='recordState'
                  checkedChildren="开启" 
                  unCheckedChildren="停用" 
                  checked={detailData.get('recordState') === 0}
                  onChange={(checked) => setDetailData({ recordState: checked ? 0 : 1 })} // 修正 here
                />
              </div>
               
            </MaterialFormItem>
            <MaterialFormItem
              labelWidth={60}
              labelText="模版文本"
              justify="center"
            >
              <Input
                style={
                  {minHeight: 86, maxHeight: 200, lineHeight: '17px', 
                    fontFamily: 'PingFangSC-Regular', padding: 8 }
                }
                className="createAccount-input"
                placeholder='请输入模版文本'
                type='textarea'
                name='template'
                value={detailData.get('template')}
                onChange={(e) => setDetailData({ template: e.target.value })}
              />
            </MaterialFormItem>
          </MaterialForm>
        </MaterialModal>
      </div>
    )
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/app/pages/preview/template/containers/DataTable.js